<script setup lang="ts">
import type { MenuLink } from '@/types/common'

import HeaderMenu from '@/components/Header/HeaderMenu.vue'

import logo from '@/assets/images/logo.svg'

type Props = {
  isShowNavMenu: boolean
  menuLinks: MenuLink[]
}

type Emits = {
  (fn: 'onShowSidebar'): void
}

defineProps<Props>()

const emit = defineEmits<Emits>()
</script>

<template>
  <header class="header" data-test-id="header">
    <nuxt-link class="header__link" to="/" data-test-id="header-logo-link">
      <nuxt-img
        class="header__brand"
        :src="logo"
        aria-label="Перейти на главную страницу для выбора города"
        alt="Логотип компании 'FARFOR'"
        loading="eager"
        data-test-id="header-logo"
      />
    </nuxt-link>

    <header-menu
      :is-show-nav-menu="isShowNavMenu"
      :menu-links="menuLinks"
      data-test-id="header-menu"
      @on-show-sidebar="emit('onShowSidebar')"
    />
  </header>
</template>

<style scoped lang="scss">
.header {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1005;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px; // 40 - высота гамбургера + 20 отступ сверху
  padding: 20px 20px 0 20px;

  @include media($bp-tablet) {
    height: 121px; // 68 - высота лого + 53 отступ сверху
    padding: 53px 20px 0 20px;
  }

  @include media($bp-desktop-mini) {
    justify-content: flex-start;
    height: 90px; // 50 - высота лого + 40 отступ сверху
    padding: 40px 0 0;
  }

  &__link {
    display: flex;
  }

  &__brand {
    width: 144px;
    height: 41px;

    @include media($bp-tablet) {
      width: 258px;
      height: 74px;
    }

    @include media($bp-desktop-mini) {
      width: 190px;
      height: 54px;
      margin-right: 120px;
    }
  }
}
</style>
